import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import * as _pdfjsLib from 'pdfjs-dist/build/pdf';
import { GlobalWorkerOptions } from 'pdfjs-dist';

(GlobalWorkerOptions as any).workerSrc = 'assets/pdf.worker.min.js';

if (environment.production || environment.stage) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule);
